import { getModuleSortConfig } from 'components/TableControls/sortOptions';

import { Filters } from 'types/filters';
import { ModuleSortConfig } from 'types/sorting';

import { AppModules } from 'constants/enums';
import { MODULE_DEFAULT_FACET_FIELDS } from 'constants/facets';
import { DEFAULT_FILTERS } from 'constants/uiSettings';

import { normalizePageSizeForModule } from './filtersUtils';

const getSortConfigForModule = (
  activeModule: AppModules,
  sortConfigByModule: ReturnType<typeof getModuleSortConfig>
): ModuleSortConfig | null => {
  switch (activeModule) {
    case AppModules.Jobseekers:
      return sortConfigByModule.jobseekers;
    case AppModules.Jobs:
      return sortConfigByModule.jobs;
    case AppModules.Applications:
      return sortConfigByModule.applications;
    case AppModules.Clients:
      return sortConfigByModule.clients;
    case AppModules.Ace:
      return sortConfigByModule.ace;
    case AppModules.RecruitmentOverviewReport:
      return sortConfigByModule.recruitmentOverviewReport;
    default:
      return null;
  }
};

export const getModuleDefaultFilters = (
  activeModule: AppModules | null,
  t: (key: string) => string
): Partial<Filters> | null => {
  if (!activeModule) {
    return null;
  }

  const sortConfigByModule = getModuleSortConfig(t);
  const sortConfig = getSortConfigForModule(activeModule, sortConfigByModule);

  const defaultSort =
    sortConfig?.defaultOption && sortConfig.options[sortConfig.defaultOption];
  const moduleDefaultFacetFields = MODULE_DEFAULT_FACET_FIELDS[activeModule];
  const moduleDefaultPageSize = normalizePageSizeForModule(
    activeModule,
    DEFAULT_FILTERS.pageSize
  );

  return {
    page: DEFAULT_FILTERS.page,
    ...(moduleDefaultPageSize !== undefined && {
      pageSize: moduleDefaultPageSize
    }),
    ...(defaultSort && {
      sortField: defaultSort.field,
      order: defaultSort.order ?? null
    }),
    ...(moduleDefaultFacetFields && { facetFields: moduleDefaultFacetFields })
  };
};
